/**
 * Hebrew storefront currency display for Root to Leaf.
 * Shopify amounts, transactions and B2B pricing remain untouched.
 * Prices rendered dynamically by theme components are also localized.
 */
(() => {
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'he') return;

  const currencyCode = /\b(?:NIS|ILS)\b/g;
  const excluded = 'script,style,textarea,template,noscript,pre,code,select,[contenteditable="true"]';
  const priceContext = '[class*="price"],[class*="money"],[class*="total"],[data-testid*="price"],[data-testid*="total"]';

  function replaceCurrencyInText(node) {
    const value = node.nodeValue;
    if (!value || !/\b(?:NIS|ILS)\b/.test(value)) return;
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded)) return;

    const parentText = parent.textContent || '';
    const nearAmount = /\d/.test(value) || (parentText.length < 180 && /\d/.test(parentText));
    if (!nearAmount && !parent.closest(priceContext)) return;

    const localized = value.replace(currencyCode, 'ש״ח');
    if (localized !== value) node.nodeValue = localized;
  }

  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      replaceCurrencyInText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) replaceCurrencyInText(walker.currentNode);
  }

  function start() {
    if (!document.body) return;
    scan(document.body);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') replaceCurrencyInText(record.target);
        for (const added of record.addedNodes) scan(added);
      }
    });
    observer.observe(document.body, {subtree: true, childList: true, characterData: true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
